// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets//images/product/ecom.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets//images/product/crm.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets//images/product/ecomlite.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets//images/product/eservice.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets//images/product/hr.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets//images/product/ims.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets//images/product/payroll.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets//images/product/pos.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets//images/product/stock.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 700px) {
  .productsIntro_mainImage__oUqCW {
    width: 23rem;
    height: 17rem;
  }
}

@media (min-width: 701px) {
  .productsIntro_mainImage__oUqCW {
    width: 40rem;
    height: 30rem;
  }
}

/* nex  */

.productsIntro_topContentMainContainerEcom__uxTbT,
.productsIntro_topContentMainContainerCrm__\\+PCYn,
.productsIntro_topContentMainContainerEcomlite__IkuTO,
.productsIntro_topContentMainContainerEservices__OIK9I,
.productsIntro_topContentMainContainerHr__-1lcy,
.productsIntro_topContentMainContainerIms__yG1yN,
.productsIntro_topContentMainContainerPayroll__CSoKv,
.productsIntro_topContentMainContainerPos__Gg61g,
.productsIntro_topContentMainContainerStock__NzsrN {
  position: relative;
  width: 100%;
  height: 600px;
  border-radius: 0px 0px 100px 100px;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  z-index: 1;
}

.productsIntro_topContentMainContainerEcom__uxTbT {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.productsIntro_topContentMainContainerCrm__\\+PCYn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.productsIntro_topContentMainContainerEcomlite__IkuTO {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.productsIntro_topContentMainContainerEservices__OIK9I {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.productsIntro_topContentMainContainerHr__-1lcy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.productsIntro_topContentMainContainerIms__yG1yN {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.productsIntro_topContentMainContainerPayroll__CSoKv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.productsIntro_topContentMainContainerPos__Gg61g {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.productsIntro_topContentMainContainerStock__NzsrN {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}




.productsIntro_productCoverBlackBox__7OfwR {
  width: 100%;
  position: absolute;
  z-index: 2;
}

.productsIntro_topContentBox__y\\+7Xi {
  width: 50%;
  margin: 100px;
  position: relative;
  z-index: 3;
}

.productsIntro_productTopHeader__AD\\+HA {
  color: #ffffff;
  font-weight: 800;
  margin-top: 150px;
}

.productsIntro_productTopBody__GIuVh {
  color: #ffffff;
  margin-top: 20px;
  font-weight: 200;
}

/* new  */




.productsIntro_outerContainer__-W41o {
  margin-left: 3.2rem;
  margin-right: 3.2rem;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

}

.productsIntro_titelFirsttxt__3AUj8 {
  color: #097ea8;
  letter-spacing: 2px;
  font-weight: 300;
  margin: 20px;
}

.productsIntro_textContainer__e1rTu {
  display: flex;
  align-items: center;
}

.productsIntro_topic__qWuvb {
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  margin: 0;
}

.productsIntro_description__0gmC2 {
  width: 30rem;
  margin: 1rem 0;
  padding: 0 12rem 0 0;
}



/* mid part */

.productsIntro_PageContainer__WUXJX {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem;
}

.productsIntro_PageTitle__aGgTo {
  color: #414141;
  font-size: 36px;
  font-weight: 600;
  line-height: 120%;
}

.productsIntro_PageImage__Ssy7y {
  width: 100%;
  height: auto;
  flex-shrink: 0;
  margin: 50px 0;
}

.productsIntro_PageDescription__ghnCj {
  color: #000;
  text-align: justify;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  width: 100%;
  flex-shrink: 0;
  margin: 20px 0;
}

.productsIntro_PageSubtitle__nwKgH {
  color: #000;
  text-align: justify;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  width: 100%;
  flex-shrink: 0;
  margin-top: 1rem;
}

.productsIntro_PageKeyFeatures__xQzD\\+ {
  color: #000;
  text-align: justify;
  font-size: 20px;
  font-weight: 600;
  line-height: 150%;
  margin-top: 3rem;
  margin-bottom: 2rem;
}



/* bottom part */

.productsIntro_descriptionContainer__t\\+lYq {
  display: flex;
  align-items: flex-start;
  margin-bottom: 4rem;
  margin-top: 4rem;
}

.productsIntro_descriptionItem__\\+fq3V {
  display: flex;
  align-items: flex-start;
  text-align: left;
  margin: 0 20px;
}

.productsIntro_bullet__1kSPI {
  color: #097ea8;
  margin-right: 8px;

}


.productsIntro_descriptionTopic__fQyBB {
  color: #292828;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 10px;
}

.productsIntro_descriptionText__cdb2f {
  width: 420px;
  color: #000;
  text-align: justify;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}


@media (max-width: 767px) {

  .productsIntro_descriptionItem__\\+fq3V {
    margin-bottom: 20px;
    width: 100%;
  }

  @media (max-width: 700px) {
    .productsIntro_mainImage__oUqCW {
      width: 23rem;
      height: 17rem;
    }

    .productsIntro_description__0gmC2 {
      width: 100%;
      padding: 0 1rem 0 0;
    }

    .productsIntro_descriptionItem__\\+fq3V {
      margin: 0;
    }

    .productsIntro_descriptionText__cdb2f {
      width: 100%;
    }


  }
}

@media (max-width: 700px) {
  .productsIntro_mainImage__oUqCW {
    width: 23rem;
    height: 17rem;
  }

  .productsIntro_description__0gmC2 {
    width: 100%;
    padding: 0 1rem 0 0;
  }

  .productsIntro_descriptionItem__\\+fq3V {
    margin: 0;
  }

  .productsIntro_descriptionText__cdb2f {
    width: 370px;
  }


  .productsIntro_topContentBox__y\\+7Xi {
    margin: 10px;
  }

  .productsIntro_productTopHeader__AD\\+HA {
    font-weight: 600;
    font-size: 24px;
    margin-top: 100px;
  }

  .productsIntro_productTopBody__GIuVh {
    margin-top: 10px;
    font-size: 16px;
  }

  .productsIntro_topContentBox__y\\+7Xi {
    width: 80%;
  }

}



@media (max-width:1024px) {
  .productsIntro_descriptionText__cdb2f {
    width: 300px;
  }

  .productsIntro_productTopHeader__AD\\+HA {
    font-size: 48px;
    margin-top: 100px;

  }

  .productsIntro_topContentBox__y\\+7Xi {
    width: 70%;
    margin: 100px;
  }

  .productsIntro_productCoverBlackBox__7OfwR {
    height: 650px;
  }

  .productsIntro_productTopBody__GIuVh {
    font-size: 20px;
  }
}

@media (max-width:770px) {
  .productsIntro_descriptionContainer__t\\+lYq {
    flex-direction: column;
  }

  .productsIntro_productTopHeader__AD\\+HA {
    font-size: 36px;
    margin-top: 50px;

  }

  .productsIntro_productTopBody__GIuVh {
    font-size: 16px;
  }

  .productsIntro_topContentBox__y\\+7Xi {
    margin: 50px;
  }

  .productsIntro_topContentMainContainerEcom__uxTbT,
  .productsIntro_topContentMainContainerCrm__\\+PCYn,
  .productsIntro_topContentMainContainerEcomlite__IkuTO,
  .productsIntro_topContentMainContainerEservices__OIK9I,
  .productsIntro_topContentMainContainerHr__-1lcy,
  .productsIntro_topContentMainContainerIms__yG1yN,
  .productsIntro_topContentMainContainerPayroll__CSoKv,
  .productsIntro_topContentMainContainerPos__Gg61g,
  .productsIntro_topContentMainContainerStock__NzsrN {
    border-radius: 0px 0px 50px 50px;
    height: 450px;
  }
}

@media (max-width:480px) {
  .productsIntro_productTopHeader__AD\\+HA {
    margin-top: 20px;
    font-size: 18px;
  }

  .productsIntro_productTopBody__GIuVh {
    font-size: 8px;
  }

  .productsIntro_topContentBox__y\\+7Xi {
    margin: 10px;
    width: 75%;
  }

  .productsIntro_topContentMainContainerEcom__uxTbT,
  .productsIntro_topContentMainContainerCrm__\\+PCYn,
  .productsIntro_topContentMainContainerEcomlite__IkuTO,
  .productsIntro_topContentMainContainerEservices__OIK9I,
  .productsIntro_topContentMainContainerHr__-1lcy,
  .productsIntro_topContentMainContainerIms__yG1yN,
  .productsIntro_topContentMainContainerPayroll__CSoKv,
  .productsIntro_topContentMainContainerPos__Gg61g,
  .productsIntro_topContentMainContainerStock__NzsrN {
    border-radius: 0px 0px 20px 20px;
    height: 210px;
  }
  .productsIntro_titelFirsttxt__3AUj8 {
    font-size: 18px;
    margin: 10px;
  }
  .productsIntro_descriptionTopic__fQyBB{
    font-size: 14px;
  }
  .productsIntro_descriptionText__cdb2f{
    font-size: 11px;
  }
  
.productsIntro_outerContainer__-W41o {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 50px;
}
}`, "",{"version":3,"sources":["webpack://./src/components/productsPages/productsIntro.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,SAAS;;AAET;;;;;;;;;EASE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yDAA8D;AAChE;;AAEA;EACE,yDAA6D;AAC/D;;AAEA;EACE,yDAAkE;AACpE;;AAEA;EACE,yDAAkE;AACpE;;AAEA;EACE,yDAA4D;AAC9D;;AAEA;EACE,yDAA6D;AAC/D;;AAEA;EACE,yDAAiE;AACnE;;AAEA;EACE,yDAA6D;AAC/D;;AAEA;EACE,yDAA+D;AACjE;;;;;AAKA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,SAAS;;;;;AAKT;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;;AAEpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;;;AAIA,aAAa;;AAEb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;;;AAIA,gBAAgB;;AAEhB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;;AAEnB;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;;EAEE;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE;MACE,YAAY;MACZ,aAAa;IACf;;IAEA;MACE,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,WAAW;IACb;;;EAGF;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;AAEF;;;;AAIA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;;EAEnB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;;EAElB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;;;;;;;;IASE,gCAAgC;IAChC,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;;;;;;;;;IASE,gCAAgC;IAChC,aAAa;EACf;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;AAEF;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA","sourcesContent":["@media (max-width: 700px) {\r\n  .mainImage {\r\n    width: 23rem;\r\n    height: 17rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 701px) {\r\n  .mainImage {\r\n    width: 40rem;\r\n    height: 30rem;\r\n  }\r\n}\r\n\r\n/* nex  */\r\n\r\n.topContentMainContainerEcom,\r\n.topContentMainContainerCrm,\r\n.topContentMainContainerEcomlite,\r\n.topContentMainContainerEservices,\r\n.topContentMainContainerHr,\r\n.topContentMainContainerIms,\r\n.topContentMainContainerPayroll,\r\n.topContentMainContainerPos,\r\n.topContentMainContainerStock {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 600px;\r\n  border-radius: 0px 0px 100px 100px;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  overflow: hidden;\r\n  z-index: 1;\r\n}\r\n\r\n.topContentMainContainerEcom {\r\n  background-image: url('../../assets//images/product/ecom.jpg');\r\n}\r\n\r\n.topContentMainContainerCrm {\r\n  background-image: url('../../assets//images/product/crm.jpg');\r\n}\r\n\r\n.topContentMainContainerEcomlite {\r\n  background-image: url('../../assets//images/product/ecomlite.jpg');\r\n}\r\n\r\n.topContentMainContainerEservices {\r\n  background-image: url('../../assets//images/product/eservice.jpg');\r\n}\r\n\r\n.topContentMainContainerHr {\r\n  background-image: url('../../assets//images/product/hr.jpg');\r\n}\r\n\r\n.topContentMainContainerIms {\r\n  background-image: url('../../assets//images/product/ims.jpg');\r\n}\r\n\r\n.topContentMainContainerPayroll {\r\n  background-image: url('../../assets//images/product/payroll.jpg');\r\n}\r\n\r\n.topContentMainContainerPos {\r\n  background-image: url('../../assets//images/product/pos.jpg');\r\n}\r\n\r\n.topContentMainContainerStock {\r\n  background-image: url('../../assets//images/product/stock.jpg');\r\n}\r\n\r\n\r\n\r\n\r\n.productCoverBlackBox {\r\n  width: 100%;\r\n  position: absolute;\r\n  z-index: 2;\r\n}\r\n\r\n.topContentBox {\r\n  width: 50%;\r\n  margin: 100px;\r\n  position: relative;\r\n  z-index: 3;\r\n}\r\n\r\n.productTopHeader {\r\n  color: #ffffff;\r\n  font-weight: 800;\r\n  margin-top: 150px;\r\n}\r\n\r\n.productTopBody {\r\n  color: #ffffff;\r\n  margin-top: 20px;\r\n  font-weight: 200;\r\n}\r\n\r\n/* new  */\r\n\r\n\r\n\r\n\r\n.outerContainer {\r\n  margin-left: 3.2rem;\r\n  margin-right: 3.2rem;\r\n  margin-top: 100px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n\r\n}\r\n\r\n.titelFirsttxt {\r\n  color: #097ea8;\r\n  letter-spacing: 2px;\r\n  font-weight: 300;\r\n  margin: 20px;\r\n}\r\n\r\n.textContainer {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.topic {\r\n  font-size: 3rem;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n\r\n.description {\r\n  width: 30rem;\r\n  margin: 1rem 0;\r\n  padding: 0 12rem 0 0;\r\n}\r\n\r\n\r\n\r\n/* mid part */\r\n\r\n.PageContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  padding: 2rem;\r\n}\r\n\r\n.PageTitle {\r\n  color: #414141;\r\n  font-size: 36px;\r\n  font-weight: 600;\r\n  line-height: 120%;\r\n}\r\n\r\n.PageImage {\r\n  width: 100%;\r\n  height: auto;\r\n  flex-shrink: 0;\r\n  margin: 50px 0;\r\n}\r\n\r\n.PageDescription {\r\n  color: #000;\r\n  text-align: justify;\r\n  text-align: center;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  width: 100%;\r\n  flex-shrink: 0;\r\n  margin: 20px 0;\r\n}\r\n\r\n.PageSubtitle {\r\n  color: #000;\r\n  text-align: justify;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 150%;\r\n  width: 100%;\r\n  flex-shrink: 0;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.PageKeyFeatures {\r\n  color: #000;\r\n  text-align: justify;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  margin-top: 3rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n\r\n\r\n/* bottom part */\r\n\r\n.descriptionContainer {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  margin-bottom: 4rem;\r\n  margin-top: 4rem;\r\n}\r\n\r\n.descriptionItem {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  text-align: left;\r\n  margin: 0 20px;\r\n}\r\n\r\n.bullet {\r\n  color: #097ea8;\r\n  margin-right: 8px;\r\n\r\n}\r\n\r\n\r\n.descriptionTopic {\r\n  color: #292828;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.descriptionText {\r\n  width: 420px;\r\n  color: #000;\r\n  text-align: justify;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 150%;\r\n}\r\n\r\n\r\n@media (max-width: 767px) {\r\n\r\n  .descriptionItem {\r\n    margin-bottom: 20px;\r\n    width: 100%;\r\n  }\r\n\r\n  @media (max-width: 700px) {\r\n    .mainImage {\r\n      width: 23rem;\r\n      height: 17rem;\r\n    }\r\n\r\n    .description {\r\n      width: 100%;\r\n      padding: 0 1rem 0 0;\r\n    }\r\n\r\n    .descriptionItem {\r\n      margin: 0;\r\n    }\r\n\r\n    .descriptionText {\r\n      width: 100%;\r\n    }\r\n\r\n\r\n  }\r\n}\r\n\r\n@media (max-width: 700px) {\r\n  .mainImage {\r\n    width: 23rem;\r\n    height: 17rem;\r\n  }\r\n\r\n  .description {\r\n    width: 100%;\r\n    padding: 0 1rem 0 0;\r\n  }\r\n\r\n  .descriptionItem {\r\n    margin: 0;\r\n  }\r\n\r\n  .descriptionText {\r\n    width: 370px;\r\n  }\r\n\r\n\r\n  .topContentBox {\r\n    margin: 10px;\r\n  }\r\n\r\n  .productTopHeader {\r\n    font-weight: 600;\r\n    font-size: 24px;\r\n    margin-top: 100px;\r\n  }\r\n\r\n  .productTopBody {\r\n    margin-top: 10px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .topContentBox {\r\n    width: 80%;\r\n  }\r\n\r\n}\r\n\r\n\r\n\r\n@media (max-width:1024px) {\r\n  .descriptionText {\r\n    width: 300px;\r\n  }\r\n\r\n  .productTopHeader {\r\n    font-size: 48px;\r\n    margin-top: 100px;\r\n\r\n  }\r\n\r\n  .topContentBox {\r\n    width: 70%;\r\n    margin: 100px;\r\n  }\r\n\r\n  .productCoverBlackBox {\r\n    height: 650px;\r\n  }\r\n\r\n  .productTopBody {\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n@media (max-width:770px) {\r\n  .descriptionContainer {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .productTopHeader {\r\n    font-size: 36px;\r\n    margin-top: 50px;\r\n\r\n  }\r\n\r\n  .productTopBody {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .topContentBox {\r\n    margin: 50px;\r\n  }\r\n\r\n  .topContentMainContainerEcom,\r\n  .topContentMainContainerCrm,\r\n  .topContentMainContainerEcomlite,\r\n  .topContentMainContainerEservices,\r\n  .topContentMainContainerHr,\r\n  .topContentMainContainerIms,\r\n  .topContentMainContainerPayroll,\r\n  .topContentMainContainerPos,\r\n  .topContentMainContainerStock {\r\n    border-radius: 0px 0px 50px 50px;\r\n    height: 450px;\r\n  }\r\n}\r\n\r\n@media (max-width:480px) {\r\n  .productTopHeader {\r\n    margin-top: 20px;\r\n    font-size: 18px;\r\n  }\r\n\r\n  .productTopBody {\r\n    font-size: 8px;\r\n  }\r\n\r\n  .topContentBox {\r\n    margin: 10px;\r\n    width: 75%;\r\n  }\r\n\r\n  .topContentMainContainerEcom,\r\n  .topContentMainContainerCrm,\r\n  .topContentMainContainerEcomlite,\r\n  .topContentMainContainerEservices,\r\n  .topContentMainContainerHr,\r\n  .topContentMainContainerIms,\r\n  .topContentMainContainerPayroll,\r\n  .topContentMainContainerPos,\r\n  .topContentMainContainerStock {\r\n    border-radius: 0px 0px 20px 20px;\r\n    height: 210px;\r\n  }\r\n  .titelFirsttxt {\r\n    font-size: 18px;\r\n    margin: 10px;\r\n  }\r\n  .descriptionTopic{\r\n    font-size: 14px;\r\n  }\r\n  .descriptionText{\r\n    font-size: 11px;\r\n  }\r\n  \r\n.outerContainer {\r\n  margin-left: 20px;\r\n  margin-right: 20px;\r\n  margin-top: 50px;\r\n}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainImage": `productsIntro_mainImage__oUqCW`,
	"topContentMainContainerEcom": `productsIntro_topContentMainContainerEcom__uxTbT`,
	"topContentMainContainerCrm": `productsIntro_topContentMainContainerCrm__+PCYn`,
	"topContentMainContainerEcomlite": `productsIntro_topContentMainContainerEcomlite__IkuTO`,
	"topContentMainContainerEservices": `productsIntro_topContentMainContainerEservices__OIK9I`,
	"topContentMainContainerHr": `productsIntro_topContentMainContainerHr__-1lcy`,
	"topContentMainContainerIms": `productsIntro_topContentMainContainerIms__yG1yN`,
	"topContentMainContainerPayroll": `productsIntro_topContentMainContainerPayroll__CSoKv`,
	"topContentMainContainerPos": `productsIntro_topContentMainContainerPos__Gg61g`,
	"topContentMainContainerStock": `productsIntro_topContentMainContainerStock__NzsrN`,
	"productCoverBlackBox": `productsIntro_productCoverBlackBox__7OfwR`,
	"topContentBox": `productsIntro_topContentBox__y+7Xi`,
	"productTopHeader": `productsIntro_productTopHeader__AD+HA`,
	"productTopBody": `productsIntro_productTopBody__GIuVh`,
	"outerContainer": `productsIntro_outerContainer__-W41o`,
	"titelFirsttxt": `productsIntro_titelFirsttxt__3AUj8`,
	"textContainer": `productsIntro_textContainer__e1rTu`,
	"topic": `productsIntro_topic__qWuvb`,
	"description": `productsIntro_description__0gmC2`,
	"PageContainer": `productsIntro_PageContainer__WUXJX`,
	"PageTitle": `productsIntro_PageTitle__aGgTo`,
	"PageImage": `productsIntro_PageImage__Ssy7y`,
	"PageDescription": `productsIntro_PageDescription__ghnCj`,
	"PageSubtitle": `productsIntro_PageSubtitle__nwKgH`,
	"PageKeyFeatures": `productsIntro_PageKeyFeatures__xQzD+`,
	"descriptionContainer": `productsIntro_descriptionContainer__t+lYq`,
	"descriptionItem": `productsIntro_descriptionItem__+fq3V`,
	"bullet": `productsIntro_bullet__1kSPI`,
	"descriptionTopic": `productsIntro_descriptionTopic__fQyBB`,
	"descriptionText": `productsIntro_descriptionText__cdb2f`
};
export default ___CSS_LOADER_EXPORT___;
